<template>
  <form>
 

    <!-- Checkbox pour utiliser l'adresse du client - AFFICHÉE EN PREMIER -->
    <b-form-checkbox 
      v-model="useClientAddress"
      @change="copyClientAddressToLogement"
      class="custom-input mb-3"
    >
      {{ $t("Utiliser l'adresse du client") }}
    </b-form-checkbox>
    
    <!-- Select de logement - masqué quand la checkbox "Utiliser l'adresse du client" est cochée -->
    <b-form-group v-if="!useClientAddress" :label="$t('HOUSING')" class="style">
      <div class="d-flex align-items-center" style="gap: 8px">
        <multiselect
          v-model="selectedLogement"
          :searchable="true"
          :close-on-select="true"
          :multiple="false"
          :options="clientId"
          label="adresse"
          track-by="id"
          :placeholder="$t('Select')"
          class="form-input custom-placeholder custom-input"
          style="flex: 1"
        />
        <b-button
          v-if="showAddLogementButton"
          size="sm"
          variant="success"
          class="button-succes-style"
          @click.prevent.stop="$emit('add-logement')"
        >
          +
        </b-button>
      </div>
    </b-form-group>
    
    <b-form-group :label="$t('Rue')" class="mb-4">
      <b-form-input
        type="text"
     
        v-model="logementData.adresse"
        @input="onAdresseChange"
        required
        class="form-input custom-placeholder custom-input"
      ></b-form-input>
    </b-form-group>

    <b-form-group :label="$t('CITY')" class="mt-2">
      <b-form-input
        type="text"
        :placeholder="$t('CITY')"
        v-model="logementData.ville"
        @input="onVilleChange"
        class="form-input custom-placeholder custom-input"
      ></b-form-input>
    </b-form-group>

    <b-form-group :label="$t('POSTAL_CODE') + '*'" class="mt-2">
      <b-form-input
        type="text"
        :placeholder="$t('POSTAL_CODE')"
        v-model="logementData.code_postal"
        @input="onCodePostalChange"
        required
        class="form-input custom-placeholder custom-input"
      ></b-form-input>
    </b-form-group>
   
    <!-- Champs avancés du logement (propriétaire occupant, résidence principale) masqués pour l'instant
    <b-form-checkbox 
      :checked="logementData.proprietaire_occupant === 1"
      @change="
        (checked) => updateParent('proprietaire_occupant', checked ? 1 : 0)
      "
      :label="$t('Propriétaire occupant')"
      class="custom-input"
    >
      {{ $t("Propriétaire occupant") }}
    </b-form-checkbox>
    <b-form-checkbox v-if="logementData.proprietaire_occupant"
      :checked="logementData.residence_principale_proprietaire === 1"
      @change="
        (checked) =>
          updateParent('residence_principale_proprietaire', checked ? 1 : 0)
      "
      :label="$t('Résidence principale')"
      class="custom-input"
    >
      {{ $t("Résidence principale") }}
    </b-form-checkbox>
    -->
    <b-form-group :label="$t('TYPE_CHAUFFAGE')" class="mt-2">
      <b-form-select
        class="form-input custom-placeholder custom-input"
        v-model="logementData.type_chauffage"
        @input="updateParent('type_chauffage', logementData.type_chauffage)"
        :options="optionstypechauffage"
        text-field="text"
        value-field="value"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            -- {{ $t("TYPE_CHAUFFAGE") }} --
          </b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
    <b-form-group :label="$t('periode_de_construction')">
      <b-form-select
        class="form-input custom-placeholder custom-input"
        v-model="logementData.periode_de_construction"
        @input="
          updateParent(
            'periode_de_construction',
            logementData.periode_de_construction
          )
        "
        :options="optionsperiode_de_construction"
        text-field="text"
        value-field="value"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            -- {{ $t("periode_de_construction") }} --
          </b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
    <b-row>
      <b-col md="6">
        <b-form-group :label="$t('TYPE_LOGEMENT')">
          <b-form-select
            class="form-input custom-placeholder custom-input"
            v-model="logementData.type"
            @input="updateParent('type', logementData.type)"
            :options="optionstypelogement"
            text-field="text"
            value-field="value"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>
                -- {{ $t("TYPE_LOGEMENT") }} --
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('Surface habitable')">
          <b-form-input
            type="number"
            min="0"
            @paste="(event) => onPaste(event, 'logementData.surface')"
            @keydown="(event) => onKeyDownFloat(event)"
            v-model="logementData.surface"
            @input="updateParent('surface', logementData.surface)"
            required
            class="form-input custom-placeholder custom-input"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group :label="$t('CADASTRAL_PARCEL')" class="mb-4">
      <b-form-input
        type="text"
        :placeholder="$t('CADASTRAL_PARCEL')"
        v-model="logementData.parcelle_cadastrale"
        @input="
          updateParent('parcelle_cadastrale', logementData.parcelle_cadastrale)
        "
        required
        class="form-input custom-placeholder custom-input"
      ></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('equipement')">
      <b-form-select
        :placeholder="$t('equipement')"
        class="form-input custom-placeholder custom-input"
        v-model="logementData.equipement_deposee"
        :options="optionstypeEquipement_deposee"
        @input="
          updateParent('equipement_deposee', logementData.equipement_deposee)
        "
        text-field="text"
        value-field="value"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            -- {{ $t("equipement") }} --
          </b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
    <b-form-group :label="$t('Type d\'énergie')">
      <b-form-select
        class="form-input custom-placeholder custom-input"
        v-model="logementData.type_energie_equipement_deposee"
        @input="
          updateParent(
            'type_energie_equipement_deposee',
            logementData.type_energie_equipement_deposee
          )
        "
        :options="optionsType_de_combustible"
        text-field="text"
        value-field="value"
      />
    </b-form-group>

    <!-- Champs avancés (Altitude, NPDL, NPRM, NPCE) masqués pour l'instant
    <b-row>
      <b-col md="6">
        <b-form-group :label="$t('Altitude')">
          <b-form-input
            type="number"
            min="0"
            :placeholder="$t('Altitude')"
            v-model="logementData.altitude"
            @input="updateParent('altitude', logementData.altitude)"
            class="form-input custom-placeholder custom-input"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('NPDL')">
          <b-form-input
            type="text"
            :placeholder="$t('NPDL')"
            v-model="logementData.NPDL"
            @input="updateParent('NPDL', logementData.NPDL)"
            class="form-input custom-placeholder custom-input"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group :label="$t('NPRM')">
          <b-form-input
            type="text"
            :placeholder="$t('NPRM')"
            v-model="logementData.NPRM"
            @input="updateParent('NPRM', logementData.NPRM)"
            class="form-input custom-placeholder custom-input"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('NPCE')">
          <b-form-input
            type="text"
            :placeholder="$t('NPCE')"
            v-model="logementData.NPCE"
            @input="updateParent('NPCE', logementData.NPCE)"
            class="form-input custom-placeholder custom-input"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    -->
    
    <!-- Champs SIRET - affiché pour tous les types de clients -->
    <b-form-group :label="$t('SIRET')" class="mt-3">
      <b-form-input
        type="text"
        :placeholder="$t('SIRET')"
        v-model="logementData.siret"
        @input="updateParent('siret', logementData.siret)"
        class="form-input custom-placeholder custom-input"
      ></b-form-input>
    </b-form-group>
    
    <!-- Champs pour clients professionnels (secteur, site, QPV...) masqués pour l'instant
    <div v-if="isProfessionel">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Secteur d’activité')">
            <b-form-input
              type="text"
              :placeholder="$t('Secteur d’activité')"
              v-model="logementData.secteur_activite"
              @input="updateParent('secteur_activite', logementData.secteur_activite)"
              class="form-input custom-placeholder custom-input"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Nom du site')">
            <b-form-input
              type="text"
              :placeholder="$t('Nom du site')"
              v-model="logementData.nom_site"
              @input="updateParent('nom_site', logementData.nom_site)"
              class="form-input custom-placeholder custom-input"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t(' Complément d\'adresse')">
            <b-form-input
              type="text"
              v-model="logementData.complement_adresse"
              @input="updateParent('complement_adresse', logementData.complement_adresse)"
              class="form-input custom-placeholder custom-input"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Quartier QPV')">
            <b-form-input
              type="text"
              :placeholder="$t('Quartier QPV')"
              v-model="logementData.quartier_qpv"
              @input="updateParent('quartier_qpv', logementData.quartier_qpv)"
              class="form-input custom-placeholder custom-input"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Nom de quartier')">
            <b-form-input
              type="text"
              :placeholder="$t('Nom DE quartier')"
              v-model="logementData.nom_de_quartier"
              @input="updateParent('nom_de_quartier', logementData.nom_de_quartier)"
              class="form-input custom-placeholder custom-input"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Code de quartier')">
            <b-form-input
              type="text"
              :placeholder="$t('Code de quartier')"
              v-model="logementData.code_de_quartier"
              @input="updateParent('code_de_quartier', logementData.code_de_quartier)"
              class="form-input custom-placeholder custom-input"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Surface d’un sous-sol')">
            <b-form-input
              type="number"
              min="0"
              :placeholder="$t('Surface d’un sous-sol')"
              v-model="logementData.surface_au_sol"
              @input="updateParent('surface_au_sol', logementData.surface_au_sol)"
              class="form-input custom-placeholder custom-input"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
    </div>
    -->
  </form>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import {
  preventExceedingLength,
  handlePaste,
  preventExceedingLengthFloat,
} from "@/utils/inputUtils";
export default {
  props: {
    clientId: {
      type: Array,
      required: false,
      default: () => [],
    },
    showAddLogementButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    logementParentData: {
      type: Object,
      required: true,
    },
    clientType: {
      type: String,
      required: false,
      default: null,
    },
    sameTravaux: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      selected: false,
      inputSearchValue: "",
      useClientAddress: false,
      logementData: { 
        ...this.logementParentData,
        surface_au_sol: this.logementParentData?.surface_au_sol ?? null
      },
      // optionstypeEquipement_deposee: [
      //   { value: "Chaudière", text: this.$t("chaudière") },
      //   { value: "Cheminée", text: this.$t("cheminée") },
      //   { value: "Pôle", text: this.$t("pôle") },
      // ],
      optionstypeEquipement_deposee: [
  { value: "Isolation thermique en combles perdus", text: this.$t("Isolation thermique en combles perdus") },
  { value: "Poêle à granulés", text: this.$t("Poêle à granulés") },
  { value: "Isolation de points singuliers d’un réseau", text: this.$t("Isolation de points singuliers d’un réseau") },
  { value: "Isolation des murs", text: this.$t("Isolation des murs") },
  { value: "Isolation d'un plancher", text: this.$t("Isolation d'un plancher") },
  { value: "Fenêtre ou porte-fenêtre complète avec vitrage isolant", text: this.$t("Fenêtre ou porte-fenêtre complète avec vitrage isolant") },
  { value: "Isolation des toitures terrasses", text: this.$t("Isolation des toitures terrasses") },
  { value: "Chauffe-eau solaire individuel", text: this.$t("Chauffe-eau solaire individuel") },
  { value: "Chaudière biomasse individuelle", text: this.$t("Chaudière biomasse individuelle") },
  { value: "Pompe à chaleur de type air/eau", text: this.$t("Pompe à chaleur de type air/eau") },
  { value: "Rénovation globale d’un bâtiment résidentiel collectif", text: this.$t("Rénovation globale d’un bâtiment résidentiel collectif") },
  { value: "Rénovation d’ampleur d’un appartement", text: this.$t("Rénovation d’ampleur d’un appartement") },
  { value: "Rénovation d’ampleur d’une maison individuelle", text: this.$t("Rénovation d’ampleur d’une maison individuelle") }
],

      optionsType_de_combustible: [
        { value: null, text: this.$t("Aucune énergie sélectionnée") },
        { value: "Granulé", text: this.$t("granulé") },
        { value: "Fioul", text: this.$t("Fuel") },
        { value: "Gaz", text: this.$t("Gaz") },
      ],
      optionstypechauffage: [
        { value: "Combustible/bois", text: this.$t("Combustible/Bois") },
        { value: "Electrique", text: this.$t("Electrique") },
        { value: "Gaz", text: this.$t("Gaz") },
        // { value: "GPL", text: this.$t("GPL") },
        { value: "Fioul", text: this.$t("Fuel") },
        { value: "Bois", text: this.$t("Bois") },
        { value: "ENR/PAC", text: "ENR/PAC" },
      ],
      optionstypelogement: [
        { value: "Maison individuelle", text: this.$t("Maison individuelle") },
        { value: "Appartement", text: this.$t("Appartement") },
        {value: "Industrie", text: this.$t("Industrie")},
        {value: "Réseau", text: this.$t("Réseau")},
        {value: "Transport", text: this.$t("Transport")},
         { value: "Agriculture", text: this.$t("Agriculture") },
      ],
      optionsperiode_de_construction: [
        { value: "moins de 2 ans", text: this.$t("Moins_de_2_ans") },
        {
          value: "de 2 à 10 ans",
          text: this.$t("De 2 à 10 ans"),
        },
        { value: "de 10 à 15 ans", text: this.$t("De 10 à 15 ans") },
        { value: "au moins 15 ans", text: this.$t("Plus_de_15_ans") },
      ],
    };
  },
  created() {
    console.log('LogementStep CREATED: sameTravaux =', this.sameTravaux);
    console.log('LogementStep CREATED: useClientAddress =', this.useClientAddress);
  },
  mounted() {
    console.log('LogementStep MOUNTED: sameTravaux =', this.sameTravaux);
    console.log('LogementStep MOUNTED: useClientAddress =', this.useClientAddress);
    this.$nextTick(() => {
      console.log('LogementStep MOUNTED NEXTICK: sameTravaux =', this.sameTravaux, 'useClientAddress =', this.useClientAddress);
    });
  },
  computed: {
    ...mapGetters(["getdevisMonoFiche", "getOnlineUser"]),
    isProfessionel() {
      if (!this.clientType) return false;
      const professionalTypes = [
        'type.professionnel',
        'type.bailleur_sociale',
        'type.syndic_copropriete_professionnel',
        'type.entreprise',
        'type.etablissement',
        'type.collectivite_territoriale_mairie',
        'type.organisation_professionnelle',
        'type.syndic_copropriete_benevole'
      ];
      return professionalTypes.includes(this.clientType);
    },
    selectedLogement: {
      get() {
        const id = this.logementData?.id;
        const hasId = id != null && id !== '';
        const hasList = Array.isArray(this.clientId) && this.clientId.length > 0;
        // Sélection par devis.logement_id : chercher l'entrée dans la liste
        if (hasId && hasList) {
          const found = this.clientId.find(
            (option) => Number(option.id) === Number(id)
          );
          return found || null;
        }
        // Pas d'id ou liste vide : select à null
        return null;
      },
      set(value) {
        if (value) {
          const updatedData = {
            ...value,
            id: value.id || null, // S'assurer que l'ID est inclus
            parcelle_cadastrale: value.parcelle_cadastrale || null,
            equipement_deposee: value.equipement_deposee || null,
            type_energie_equipement_deposee:
              value.type_energie_equipement_deposee || null,
            type_chauffage: value.type_chauffage || null,
            type_logement: value.type_logement || null,
            periode_de_construction: value.periode_de_construction || null,
            surface: value.surface || null,
            type: value.type || null,
            adresse: value.adresse || null,
            altitude: value.altitude || null,
            NPDL: value.NPDL || null,
            NPRM: value.NPRM || null,
            NPCE: value.NPCE || null,
            secteur_activite: value.secteur_activite || null,
            siret: value.siret || null,
            nom_site: value.nom_site || null,
            complement: value.complement || null,
            code_postal: value.code_postal || null,
            complement_adresse: value.complement_adresse || null,
            ville: value.ville || null,
            quartier_qpv: value.quartier_qpv || null,
            nom_de_quartier: value.nom_de_quartier || null,
            code_de_quartier: value.code_de_quartier || null,
            surface_au_sol: value.surface_au_sol || null,
          };

          Object.keys(updatedData).forEach((field) => {
            this.updateParent(field, updatedData[field]);
          });

          this.logementData = updatedData;
          this.selected = true;
        } else {
          const resetData = {
            id: null,
            parcelle_cadastrale: null,
            equipement_deposee: null,
            type_energie_equipement_deposee: null,
            type_chauffage: null,
            type_logement: null,
            periode_de_construction: null,
            surface: null,
            type: null,
            adresse: null,
            altitude: null,
            NPDL: null,
            NPRM: null,
            NPCE: null,
            secteur_activite: null,
            siret: null,
            nom_site: null,
            complement: null,
            code_postal: null,
            complement_adresse: null,
            ville: null,
            quartier_qpv: null,
            nom_de_quartier: null,
            code_de_quartier: null,
            surface_au_sol: null,
          };

          Object.keys(resetData).forEach((field) => {
            this.updateParent(field, resetData[field]);
          });

          this.logementData = resetData;
          this.selected = false;
        }
      },
    },
  },
  watch: {
    sameTravaux: {
      handler(newValue) {
        // Initialiser useClientAddress basée sur la valeur de sameTravaux du parent
        console.log('WATCH sameTravaux: newValue =', newValue, 'type =', typeof newValue);
        if (newValue === 1 || newValue === "1") {
          console.log('Setting useClientAddress to TRUE');
          this.useClientAddress = true;
        } else {
          console.log('Setting useClientAddress to FALSE');
          this.useClientAddress = false;
        }
        console.log('After update: this.useClientAddress =', this.useClientAddress);
      },
      immediate: true
    },
    clientId: {
      immediate: true,
      handler(newClientId, oldClientId) {
        // Reset form uniquement si la liste change alors qu'elle était déjà remplie
        // (éviter de reset lors du premier chargement [] -> [logements])
        if (
          newClientId !== oldClientId &&
          Array.isArray(oldClientId) &&
          oldClientId.length > 0
        ) {
          this.resetForm();
        }
      }
    },
    inputSearchValue(newValue) {
      if (newValue.trim() === "") {
        this.selected = false;
      }
    },
    logementParentData: {
      deep: true,
      handler(newData) {
        this.logementData = { 
          ...newData,
          surface_au_sol: newData?.surface_au_sol ?? null
        };
      },
    },
  },
  methods: {
    ...mapActions(["editLogement", "storeLogement"]),
    resetForm() {
    const resetData = {
      parcelle_cadastrale: null,
      equipement_deposee: null,
      type_energie_equipement_deposee: null,
      type_chauffage: null,
      type_logement: null,
      periode_de_construction: null,
      surface: null,
      type: null,
      adresse: null,
      proprietaire_occupant: 0,
      residence_principale_proprietaire: 0,
      altitude: null,
      NPDL: null,
      NPRM: null,
      NPCE: null,
      secteur_activite: null,
      siret: null,
      nom_site: null,
      complement: null,
      code_postal: null,
      complement_adresse: null,
      ville: null,
      quartier_qpv: null,
      nom_de_quartier: null,
      code_de_quartier: null,
      surface_au_sol: null,
    };

    Object.keys(resetData).forEach((field) => {
      this.updateParent(field, resetData[field]);
    });

    this.logementData = resetData;
    this.selected = false;
    this.selectedLogement = null;
  },
    onAdresseChange() {
      // Quand l'adresse change manuellement, on met à jour le parent...
      this.updateParent('adresse', this.logementData.adresse);
      // ...et on désélectionne uniquement le lien avec le logement (id), sans vider les champs
      this.updateParent('id', null);
    },
    onCodePostalChange() {
      this.updateParent('code_postal', this.logementData.code_postal);
      // Changement de CP => on coupe le lien avec le logement sélectionné
      this.updateParent('id', null);
    },
    onVilleChange() {
      this.updateParent('ville', this.logementData.ville);
      // Changement de ville => on coupe le lien avec le logement sélectionné
      this.updateParent('id', null);
    },
    onKeyDown(event) {
      preventExceedingLength(event);
    },
    updateParent(field, value) {
      this.$emit("update-logement", { field, value });
    },
    copyClientAddressToLogement() {
      if (this.useClientAddress && this.logementParentData) {
        // Copier l'adresse, la ville et le code postal du client au logement
        const clientData = this.$parent.clientData;
        
        console.log('DEBUG CHECKBOX: useClientAddress =', this.useClientAddress);
        console.log('DEBUG CHECKBOX: clientData =', clientData);
        
        if (clientData) {
          // Copier l'adresse du client
          const newAdresse = clientData.rue || this.logementData.adresse;
          const newCodePostal = clientData.cp || this.logementData.code_postal;
          const newVille = clientData.ville || this.logementData.ville;
          const newComplement = clientData.complement_adresse || this.logementData.complement_adresse;
          
          console.log('DEBUG CHECKBOX: newAdresse =', newAdresse);
          console.log('DEBUG CHECKBOX: newCodePostal =', newCodePostal);
          console.log('DEBUG CHECKBOX: newVille =', newVille);
          
          // Mettre à jour le formulaire
          this.updateParent('adresse', newAdresse);
          this.updateParent('code_postal', newCodePostal);
          this.updateParent('ville', newVille);
          this.updateParent('complement_adresse', newComplement);
          
          // Mettre à jour les données locales
          this.logementData.adresse = newAdresse;
          this.logementData.code_postal = newCodePostal;
          this.logementData.ville = newVille;
          this.logementData.complement_adresse = newComplement;
          
          console.log('DEBUG CHECKBOX: Updated logementData =', this.logementData);
          
          // Émettre l'événement pour mettre à jour same_travaux_address
          this.$emit('update-same-travaux-address', 1);
        }
      } else {
        console.log('DEBUG CHECKBOX: Checkbox unchecked or no parent data');
        // Émettre l'événement pour mettre à jour same_travaux_address quand on décoche
        this.$emit('update-same-travaux-address', 0);
      }
    },
    onKeyDownFloat(event) {
      preventExceedingLengthFloat(event);
    },
    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },
  },
};
</script>
